/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UserLayoutImport } from './routes/_user-layout'
import { Route as AuthenticationLayoutImport } from './routes/_authentication-layout'
import { Route as UserLayoutProfileProfileLayoutImport } from './routes/_user-layout/profile/_profile-layout'
import { Route as UserLayoutManagementManagementLayoutImport } from './routes/_user-layout/management/_management-layout'
import { Route as UserLayoutHelpHelpLayoutImport } from './routes/_user-layout/help/_help-layout'
import { Route as UserLayoutAbonnementPaiementImport } from './routes/_user-layout/Abonnement/paiement'

// Create Virtual Routes

const VerifyEmailLazyImport = createFileRoute('/verify-email')()
const SimulateurLazyImport = createFileRoute('/simulateur')()
const UserLayoutProfileImport = createFileRoute('/_user-layout/profile')()
const UserLayoutManagementImport = createFileRoute('/_user-layout/management')()
const UserLayoutHelpImport = createFileRoute('/_user-layout/help')()
const UserLayoutIndexLazyImport = createFileRoute('/_user-layout/')()
const UserLayoutUserInfoIndexLazyImport = createFileRoute(
  '/_user-layout/user-info/',
)()
const UserLayoutTransactionsIndexLazyImport = createFileRoute(
  '/_user-layout/transactions/',
)()
const UserLayoutOptimizationIndexLazyImport = createFileRoute(
  '/_user-layout/optimization/',
)()
const UserLayoutAccountsListIndexLazyImport = createFileRoute(
  '/_user-layout/accounts-list/',
)()
const AuthenticationLayoutLoginIndexLazyImport = createFileRoute(
  '/_authentication-layout/login/',
)()
const UserLayoutProfileProfileLayoutSocialSecurityIndexLazyImport =
  createFileRoute('/_user-layout/profile/_profile-layout/social-security/')()
const UserLayoutProfileProfileLayoutProfileFiscalIndexLazyImport =
  createFileRoute('/_user-layout/profile/_profile-layout/profile-fiscal/')()
const UserLayoutProfileProfileLayoutGeneralIndexLazyImport = createFileRoute(
  '/_user-layout/profile/_profile-layout/general/',
)()
const UserLayoutProfileProfileLayoutAccountingDataIndexLazyImport =
  createFileRoute('/_user-layout/profile/_profile-layout/accounting-data/')()
const UserLayoutManagementManagementLayoutSocialContributionsIndexLazyImport =
  createFileRoute(
    '/_user-layout/management/_management-layout/social-contributions/',
  )()
const UserLayoutManagementManagementLayoutMyTaxIndexLazyImport =
  createFileRoute('/_user-layout/management/_management-layout/my-tax/')()
const UserLayoutManagementManagementLayoutMySummaryIndexLazyImport =
  createFileRoute('/_user-layout/management/_management-layout/my-summary/')()
const UserLayoutManagementManagementLayoutMyContributionsIndexLazyImport =
  createFileRoute(
    '/_user-layout/management/_management-layout/my-contributions/',
  )()
const UserLayoutManagementManagementLayoutMyBusinessIndexLazyImport =
  createFileRoute('/_user-layout/management/_management-layout/my-business/')()
const UserLayoutHelpHelpLayoutVideoExplainIndexLazyImport = createFileRoute(
  '/_user-layout/help/_help-layout/video-explain/',
)()
const UserLayoutHelpHelpLayoutTransactionActionsIndexLazyImport =
  createFileRoute('/_user-layout/help/_help-layout/transaction-actions/')()
const UserLayoutHelpHelpLayoutTaxesIndexLazyImport = createFileRoute(
  '/_user-layout/help/_help-layout/taxes/',
)()
const UserLayoutHelpHelpLayoutSpecialChargesIndexLazyImport = createFileRoute(
  '/_user-layout/help/_help-layout/special-charges/',
)()
const UserLayoutHelpHelpLayoutSocialSecurityIndexLazyImport = createFileRoute(
  '/_user-layout/help/_help-layout/social-security/',
)()
const UserLayoutHelpHelpLayoutProfileIndexLazyImport = createFileRoute(
  '/_user-layout/help/_help-layout/profile/',
)()
const UserLayoutHelpHelpLayoutOptimizationIndexLazyImport = createFileRoute(
  '/_user-layout/help/_help-layout/optimization/',
)()
const UserLayoutHelpHelpLayoutMyTransactionsIndexLazyImport = createFileRoute(
  '/_user-layout/help/_help-layout/my-transactions/',
)()
const UserLayoutHelpHelpLayoutMyOptimizationIndexLazyImport = createFileRoute(
  '/_user-layout/help/_help-layout/my-optimization/',
)()
const UserLayoutHelpHelpLayoutMyActivityIndexLazyImport = createFileRoute(
  '/_user-layout/help/_help-layout/my-activity/',
)()
const UserLayoutHelpHelpLayoutBankingIndexLazyImport = createFileRoute(
  '/_user-layout/help/_help-layout/banking/',
)()

// Create/Update Routes

const VerifyEmailLazyRoute = VerifyEmailLazyImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/verify-email.lazy').then((d) => d.Route))

const SimulateurLazyRoute = SimulateurLazyImport.update({
  id: '/simulateur',
  path: '/simulateur',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/simulateur.lazy').then((d) => d.Route))

const UserLayoutRoute = UserLayoutImport.update({
  id: '/_user-layout',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticationLayoutRoute = AuthenticationLayoutImport.update({
  id: '/_authentication-layout',
  getParentRoute: () => rootRoute,
} as any)

const UserLayoutProfileRoute = UserLayoutProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => UserLayoutRoute,
} as any)

const UserLayoutManagementRoute = UserLayoutManagementImport.update({
  id: '/management',
  path: '/management',
  getParentRoute: () => UserLayoutRoute,
} as any)

const UserLayoutHelpRoute = UserLayoutHelpImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => UserLayoutRoute,
} as any)

const UserLayoutIndexLazyRoute = UserLayoutIndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UserLayoutRoute,
} as any).lazy(() =>
  import('./routes/_user-layout/index.lazy').then((d) => d.Route),
)

const UserLayoutUserInfoIndexLazyRoute =
  UserLayoutUserInfoIndexLazyImport.update({
    id: '/user-info/',
    path: '/user-info/',
    getParentRoute: () => UserLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_user-layout/user-info/index.lazy').then((d) => d.Route),
  )

const UserLayoutTransactionsIndexLazyRoute =
  UserLayoutTransactionsIndexLazyImport.update({
    id: '/transactions/',
    path: '/transactions/',
    getParentRoute: () => UserLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_user-layout/transactions/index.lazy').then(
      (d) => d.Route,
    ),
  )

const UserLayoutOptimizationIndexLazyRoute =
  UserLayoutOptimizationIndexLazyImport.update({
    id: '/optimization/',
    path: '/optimization/',
    getParentRoute: () => UserLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_user-layout/optimization/index.lazy').then(
      (d) => d.Route,
    ),
  )

const UserLayoutAccountsListIndexLazyRoute =
  UserLayoutAccountsListIndexLazyImport.update({
    id: '/accounts-list/',
    path: '/accounts-list/',
    getParentRoute: () => UserLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_user-layout/accounts-list/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AuthenticationLayoutLoginIndexLazyRoute =
  AuthenticationLayoutLoginIndexLazyImport.update({
    id: '/login/',
    path: '/login/',
    getParentRoute: () => AuthenticationLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_authentication-layout/login/index.lazy').then(
      (d) => d.Route,
    ),
  )

const UserLayoutProfileProfileLayoutRoute =
  UserLayoutProfileProfileLayoutImport.update({
    id: '/_profile-layout',
    getParentRoute: () => UserLayoutProfileRoute,
  } as any)

const UserLayoutManagementManagementLayoutRoute =
  UserLayoutManagementManagementLayoutImport.update({
    id: '/_management-layout',
    getParentRoute: () => UserLayoutManagementRoute,
  } as any)

const UserLayoutHelpHelpLayoutRoute = UserLayoutHelpHelpLayoutImport.update({
  id: '/_help-layout',
  getParentRoute: () => UserLayoutHelpRoute,
} as any)

const UserLayoutAbonnementPaiementRoute =
  UserLayoutAbonnementPaiementImport.update({
    id: '/Abonnement/paiement',
    path: '/Abonnement/paiement',
    getParentRoute: () => UserLayoutRoute,
  } as any)

const UserLayoutProfileProfileLayoutSocialSecurityIndexLazyRoute =
  UserLayoutProfileProfileLayoutSocialSecurityIndexLazyImport.update({
    id: '/social-security/',
    path: '/social-security/',
    getParentRoute: () => UserLayoutProfileProfileLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/profile/_profile-layout/social-security/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutProfileProfileLayoutProfileFiscalIndexLazyRoute =
  UserLayoutProfileProfileLayoutProfileFiscalIndexLazyImport.update({
    id: '/profile-fiscal/',
    path: '/profile-fiscal/',
    getParentRoute: () => UserLayoutProfileProfileLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/profile/_profile-layout/profile-fiscal/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutProfileProfileLayoutGeneralIndexLazyRoute =
  UserLayoutProfileProfileLayoutGeneralIndexLazyImport.update({
    id: '/general/',
    path: '/general/',
    getParentRoute: () => UserLayoutProfileProfileLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/profile/_profile-layout/general/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutProfileProfileLayoutAccountingDataIndexLazyRoute =
  UserLayoutProfileProfileLayoutAccountingDataIndexLazyImport.update({
    id: '/accounting-data/',
    path: '/accounting-data/',
    getParentRoute: () => UserLayoutProfileProfileLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/profile/_profile-layout/accounting-data/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutManagementManagementLayoutSocialContributionsIndexLazyRoute =
  UserLayoutManagementManagementLayoutSocialContributionsIndexLazyImport.update(
    {
      id: '/social-contributions/',
      path: '/social-contributions/',
      getParentRoute: () => UserLayoutManagementManagementLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_user-layout/management/_management-layout/social-contributions/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutManagementManagementLayoutMyTaxIndexLazyRoute =
  UserLayoutManagementManagementLayoutMyTaxIndexLazyImport.update({
    id: '/my-tax/',
    path: '/my-tax/',
    getParentRoute: () => UserLayoutManagementManagementLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/management/_management-layout/my-tax/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutManagementManagementLayoutMySummaryIndexLazyRoute =
  UserLayoutManagementManagementLayoutMySummaryIndexLazyImport.update({
    id: '/my-summary/',
    path: '/my-summary/',
    getParentRoute: () => UserLayoutManagementManagementLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/management/_management-layout/my-summary/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutManagementManagementLayoutMyContributionsIndexLazyRoute =
  UserLayoutManagementManagementLayoutMyContributionsIndexLazyImport.update({
    id: '/my-contributions/',
    path: '/my-contributions/',
    getParentRoute: () => UserLayoutManagementManagementLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/management/_management-layout/my-contributions/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutManagementManagementLayoutMyBusinessIndexLazyRoute =
  UserLayoutManagementManagementLayoutMyBusinessIndexLazyImport.update({
    id: '/my-business/',
    path: '/my-business/',
    getParentRoute: () => UserLayoutManagementManagementLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/management/_management-layout/my-business/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutHelpHelpLayoutVideoExplainIndexLazyRoute =
  UserLayoutHelpHelpLayoutVideoExplainIndexLazyImport.update({
    id: '/video-explain/',
    path: '/video-explain/',
    getParentRoute: () => UserLayoutHelpHelpLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/help/_help-layout/video-explain/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutHelpHelpLayoutTransactionActionsIndexLazyRoute =
  UserLayoutHelpHelpLayoutTransactionActionsIndexLazyImport.update({
    id: '/transaction-actions/',
    path: '/transaction-actions/',
    getParentRoute: () => UserLayoutHelpHelpLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/help/_help-layout/transaction-actions/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutHelpHelpLayoutTaxesIndexLazyRoute =
  UserLayoutHelpHelpLayoutTaxesIndexLazyImport.update({
    id: '/taxes/',
    path: '/taxes/',
    getParentRoute: () => UserLayoutHelpHelpLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_user-layout/help/_help-layout/taxes/index.lazy').then(
      (d) => d.Route,
    ),
  )

const UserLayoutHelpHelpLayoutSpecialChargesIndexLazyRoute =
  UserLayoutHelpHelpLayoutSpecialChargesIndexLazyImport.update({
    id: '/special-charges/',
    path: '/special-charges/',
    getParentRoute: () => UserLayoutHelpHelpLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/help/_help-layout/special-charges/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutHelpHelpLayoutSocialSecurityIndexLazyRoute =
  UserLayoutHelpHelpLayoutSocialSecurityIndexLazyImport.update({
    id: '/social-security/',
    path: '/social-security/',
    getParentRoute: () => UserLayoutHelpHelpLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/help/_help-layout/social-security/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutHelpHelpLayoutProfileIndexLazyRoute =
  UserLayoutHelpHelpLayoutProfileIndexLazyImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => UserLayoutHelpHelpLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_user-layout/help/_help-layout/profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const UserLayoutHelpHelpLayoutOptimizationIndexLazyRoute =
  UserLayoutHelpHelpLayoutOptimizationIndexLazyImport.update({
    id: '/optimization/',
    path: '/optimization/',
    getParentRoute: () => UserLayoutHelpHelpLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/help/_help-layout/optimization/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutHelpHelpLayoutMyTransactionsIndexLazyRoute =
  UserLayoutHelpHelpLayoutMyTransactionsIndexLazyImport.update({
    id: '/my-transactions/',
    path: '/my-transactions/',
    getParentRoute: () => UserLayoutHelpHelpLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/help/_help-layout/my-transactions/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutHelpHelpLayoutMyOptimizationIndexLazyRoute =
  UserLayoutHelpHelpLayoutMyOptimizationIndexLazyImport.update({
    id: '/my-optimization/',
    path: '/my-optimization/',
    getParentRoute: () => UserLayoutHelpHelpLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/help/_help-layout/my-optimization/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutHelpHelpLayoutMyActivityIndexLazyRoute =
  UserLayoutHelpHelpLayoutMyActivityIndexLazyImport.update({
    id: '/my-activity/',
    path: '/my-activity/',
    getParentRoute: () => UserLayoutHelpHelpLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_user-layout/help/_help-layout/my-activity/index.lazy'
    ).then((d) => d.Route),
  )

const UserLayoutHelpHelpLayoutBankingIndexLazyRoute =
  UserLayoutHelpHelpLayoutBankingIndexLazyImport.update({
    id: '/banking/',
    path: '/banking/',
    getParentRoute: () => UserLayoutHelpHelpLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_user-layout/help/_help-layout/banking/index.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authentication-layout': {
      id: '/_authentication-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticationLayoutImport
      parentRoute: typeof rootRoute
    }
    '/_user-layout': {
      id: '/_user-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UserLayoutImport
      parentRoute: typeof rootRoute
    }
    '/simulateur': {
      id: '/simulateur'
      path: '/simulateur'
      fullPath: '/simulateur'
      preLoaderRoute: typeof SimulateurLazyImport
      parentRoute: typeof rootRoute
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailLazyImport
      parentRoute: typeof rootRoute
    }
    '/_user-layout/': {
      id: '/_user-layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof UserLayoutIndexLazyImport
      parentRoute: typeof UserLayoutImport
    }
    '/_user-layout/Abonnement/paiement': {
      id: '/_user-layout/Abonnement/paiement'
      path: '/Abonnement/paiement'
      fullPath: '/Abonnement/paiement'
      preLoaderRoute: typeof UserLayoutAbonnementPaiementImport
      parentRoute: typeof UserLayoutImport
    }
    '/_user-layout/help': {
      id: '/_user-layout/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof UserLayoutHelpImport
      parentRoute: typeof UserLayoutImport
    }
    '/_user-layout/help/_help-layout': {
      id: '/_user-layout/help/_help-layout'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutImport
      parentRoute: typeof UserLayoutHelpRoute
    }
    '/_user-layout/management': {
      id: '/_user-layout/management'
      path: '/management'
      fullPath: '/management'
      preLoaderRoute: typeof UserLayoutManagementImport
      parentRoute: typeof UserLayoutImport
    }
    '/_user-layout/management/_management-layout': {
      id: '/_user-layout/management/_management-layout'
      path: '/management'
      fullPath: '/management'
      preLoaderRoute: typeof UserLayoutManagementManagementLayoutImport
      parentRoute: typeof UserLayoutManagementRoute
    }
    '/_user-layout/profile': {
      id: '/_user-layout/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof UserLayoutProfileImport
      parentRoute: typeof UserLayoutImport
    }
    '/_user-layout/profile/_profile-layout': {
      id: '/_user-layout/profile/_profile-layout'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof UserLayoutProfileProfileLayoutImport
      parentRoute: typeof UserLayoutProfileRoute
    }
    '/_authentication-layout/login/': {
      id: '/_authentication-layout/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthenticationLayoutLoginIndexLazyImport
      parentRoute: typeof AuthenticationLayoutImport
    }
    '/_user-layout/accounts-list/': {
      id: '/_user-layout/accounts-list/'
      path: '/accounts-list'
      fullPath: '/accounts-list'
      preLoaderRoute: typeof UserLayoutAccountsListIndexLazyImport
      parentRoute: typeof UserLayoutImport
    }
    '/_user-layout/optimization/': {
      id: '/_user-layout/optimization/'
      path: '/optimization'
      fullPath: '/optimization'
      preLoaderRoute: typeof UserLayoutOptimizationIndexLazyImport
      parentRoute: typeof UserLayoutImport
    }
    '/_user-layout/transactions/': {
      id: '/_user-layout/transactions/'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof UserLayoutTransactionsIndexLazyImport
      parentRoute: typeof UserLayoutImport
    }
    '/_user-layout/user-info/': {
      id: '/_user-layout/user-info/'
      path: '/user-info'
      fullPath: '/user-info'
      preLoaderRoute: typeof UserLayoutUserInfoIndexLazyImport
      parentRoute: typeof UserLayoutImport
    }
    '/_user-layout/help/_help-layout/banking/': {
      id: '/_user-layout/help/_help-layout/banking/'
      path: '/banking'
      fullPath: '/help/banking'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutBankingIndexLazyImport
      parentRoute: typeof UserLayoutHelpHelpLayoutImport
    }
    '/_user-layout/help/_help-layout/my-activity/': {
      id: '/_user-layout/help/_help-layout/my-activity/'
      path: '/my-activity'
      fullPath: '/help/my-activity'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutMyActivityIndexLazyImport
      parentRoute: typeof UserLayoutHelpHelpLayoutImport
    }
    '/_user-layout/help/_help-layout/my-optimization/': {
      id: '/_user-layout/help/_help-layout/my-optimization/'
      path: '/my-optimization'
      fullPath: '/help/my-optimization'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutMyOptimizationIndexLazyImport
      parentRoute: typeof UserLayoutHelpHelpLayoutImport
    }
    '/_user-layout/help/_help-layout/my-transactions/': {
      id: '/_user-layout/help/_help-layout/my-transactions/'
      path: '/my-transactions'
      fullPath: '/help/my-transactions'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutMyTransactionsIndexLazyImport
      parentRoute: typeof UserLayoutHelpHelpLayoutImport
    }
    '/_user-layout/help/_help-layout/optimization/': {
      id: '/_user-layout/help/_help-layout/optimization/'
      path: '/optimization'
      fullPath: '/help/optimization'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutOptimizationIndexLazyImport
      parentRoute: typeof UserLayoutHelpHelpLayoutImport
    }
    '/_user-layout/help/_help-layout/profile/': {
      id: '/_user-layout/help/_help-layout/profile/'
      path: '/profile'
      fullPath: '/help/profile'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutProfileIndexLazyImport
      parentRoute: typeof UserLayoutHelpHelpLayoutImport
    }
    '/_user-layout/help/_help-layout/social-security/': {
      id: '/_user-layout/help/_help-layout/social-security/'
      path: '/social-security'
      fullPath: '/help/social-security'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutSocialSecurityIndexLazyImport
      parentRoute: typeof UserLayoutHelpHelpLayoutImport
    }
    '/_user-layout/help/_help-layout/special-charges/': {
      id: '/_user-layout/help/_help-layout/special-charges/'
      path: '/special-charges'
      fullPath: '/help/special-charges'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutSpecialChargesIndexLazyImport
      parentRoute: typeof UserLayoutHelpHelpLayoutImport
    }
    '/_user-layout/help/_help-layout/taxes/': {
      id: '/_user-layout/help/_help-layout/taxes/'
      path: '/taxes'
      fullPath: '/help/taxes'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutTaxesIndexLazyImport
      parentRoute: typeof UserLayoutHelpHelpLayoutImport
    }
    '/_user-layout/help/_help-layout/transaction-actions/': {
      id: '/_user-layout/help/_help-layout/transaction-actions/'
      path: '/transaction-actions'
      fullPath: '/help/transaction-actions'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutTransactionActionsIndexLazyImport
      parentRoute: typeof UserLayoutHelpHelpLayoutImport
    }
    '/_user-layout/help/_help-layout/video-explain/': {
      id: '/_user-layout/help/_help-layout/video-explain/'
      path: '/video-explain'
      fullPath: '/help/video-explain'
      preLoaderRoute: typeof UserLayoutHelpHelpLayoutVideoExplainIndexLazyImport
      parentRoute: typeof UserLayoutHelpHelpLayoutImport
    }
    '/_user-layout/management/_management-layout/my-business/': {
      id: '/_user-layout/management/_management-layout/my-business/'
      path: '/my-business'
      fullPath: '/management/my-business'
      preLoaderRoute: typeof UserLayoutManagementManagementLayoutMyBusinessIndexLazyImport
      parentRoute: typeof UserLayoutManagementManagementLayoutImport
    }
    '/_user-layout/management/_management-layout/my-contributions/': {
      id: '/_user-layout/management/_management-layout/my-contributions/'
      path: '/my-contributions'
      fullPath: '/management/my-contributions'
      preLoaderRoute: typeof UserLayoutManagementManagementLayoutMyContributionsIndexLazyImport
      parentRoute: typeof UserLayoutManagementManagementLayoutImport
    }
    '/_user-layout/management/_management-layout/my-summary/': {
      id: '/_user-layout/management/_management-layout/my-summary/'
      path: '/my-summary'
      fullPath: '/management/my-summary'
      preLoaderRoute: typeof UserLayoutManagementManagementLayoutMySummaryIndexLazyImport
      parentRoute: typeof UserLayoutManagementManagementLayoutImport
    }
    '/_user-layout/management/_management-layout/my-tax/': {
      id: '/_user-layout/management/_management-layout/my-tax/'
      path: '/my-tax'
      fullPath: '/management/my-tax'
      preLoaderRoute: typeof UserLayoutManagementManagementLayoutMyTaxIndexLazyImport
      parentRoute: typeof UserLayoutManagementManagementLayoutImport
    }
    '/_user-layout/management/_management-layout/social-contributions/': {
      id: '/_user-layout/management/_management-layout/social-contributions/'
      path: '/social-contributions'
      fullPath: '/management/social-contributions'
      preLoaderRoute: typeof UserLayoutManagementManagementLayoutSocialContributionsIndexLazyImport
      parentRoute: typeof UserLayoutManagementManagementLayoutImport
    }
    '/_user-layout/profile/_profile-layout/accounting-data/': {
      id: '/_user-layout/profile/_profile-layout/accounting-data/'
      path: '/accounting-data'
      fullPath: '/profile/accounting-data'
      preLoaderRoute: typeof UserLayoutProfileProfileLayoutAccountingDataIndexLazyImport
      parentRoute: typeof UserLayoutProfileProfileLayoutImport
    }
    '/_user-layout/profile/_profile-layout/general/': {
      id: '/_user-layout/profile/_profile-layout/general/'
      path: '/general'
      fullPath: '/profile/general'
      preLoaderRoute: typeof UserLayoutProfileProfileLayoutGeneralIndexLazyImport
      parentRoute: typeof UserLayoutProfileProfileLayoutImport
    }
    '/_user-layout/profile/_profile-layout/profile-fiscal/': {
      id: '/_user-layout/profile/_profile-layout/profile-fiscal/'
      path: '/profile-fiscal'
      fullPath: '/profile/profile-fiscal'
      preLoaderRoute: typeof UserLayoutProfileProfileLayoutProfileFiscalIndexLazyImport
      parentRoute: typeof UserLayoutProfileProfileLayoutImport
    }
    '/_user-layout/profile/_profile-layout/social-security/': {
      id: '/_user-layout/profile/_profile-layout/social-security/'
      path: '/social-security'
      fullPath: '/profile/social-security'
      preLoaderRoute: typeof UserLayoutProfileProfileLayoutSocialSecurityIndexLazyImport
      parentRoute: typeof UserLayoutProfileProfileLayoutImport
    }
  }
}

// Create and export the route tree

interface AuthenticationLayoutRouteChildren {
  AuthenticationLayoutLoginIndexLazyRoute: typeof AuthenticationLayoutLoginIndexLazyRoute
}

const AuthenticationLayoutRouteChildren: AuthenticationLayoutRouteChildren = {
  AuthenticationLayoutLoginIndexLazyRoute:
    AuthenticationLayoutLoginIndexLazyRoute,
}

const AuthenticationLayoutRouteWithChildren =
  AuthenticationLayoutRoute._addFileChildren(AuthenticationLayoutRouteChildren)

interface UserLayoutHelpHelpLayoutRouteChildren {
  UserLayoutHelpHelpLayoutBankingIndexLazyRoute: typeof UserLayoutHelpHelpLayoutBankingIndexLazyRoute
  UserLayoutHelpHelpLayoutMyActivityIndexLazyRoute: typeof UserLayoutHelpHelpLayoutMyActivityIndexLazyRoute
  UserLayoutHelpHelpLayoutMyOptimizationIndexLazyRoute: typeof UserLayoutHelpHelpLayoutMyOptimizationIndexLazyRoute
  UserLayoutHelpHelpLayoutMyTransactionsIndexLazyRoute: typeof UserLayoutHelpHelpLayoutMyTransactionsIndexLazyRoute
  UserLayoutHelpHelpLayoutOptimizationIndexLazyRoute: typeof UserLayoutHelpHelpLayoutOptimizationIndexLazyRoute
  UserLayoutHelpHelpLayoutProfileIndexLazyRoute: typeof UserLayoutHelpHelpLayoutProfileIndexLazyRoute
  UserLayoutHelpHelpLayoutSocialSecurityIndexLazyRoute: typeof UserLayoutHelpHelpLayoutSocialSecurityIndexLazyRoute
  UserLayoutHelpHelpLayoutSpecialChargesIndexLazyRoute: typeof UserLayoutHelpHelpLayoutSpecialChargesIndexLazyRoute
  UserLayoutHelpHelpLayoutTaxesIndexLazyRoute: typeof UserLayoutHelpHelpLayoutTaxesIndexLazyRoute
  UserLayoutHelpHelpLayoutTransactionActionsIndexLazyRoute: typeof UserLayoutHelpHelpLayoutTransactionActionsIndexLazyRoute
  UserLayoutHelpHelpLayoutVideoExplainIndexLazyRoute: typeof UserLayoutHelpHelpLayoutVideoExplainIndexLazyRoute
}

const UserLayoutHelpHelpLayoutRouteChildren: UserLayoutHelpHelpLayoutRouteChildren =
  {
    UserLayoutHelpHelpLayoutBankingIndexLazyRoute:
      UserLayoutHelpHelpLayoutBankingIndexLazyRoute,
    UserLayoutHelpHelpLayoutMyActivityIndexLazyRoute:
      UserLayoutHelpHelpLayoutMyActivityIndexLazyRoute,
    UserLayoutHelpHelpLayoutMyOptimizationIndexLazyRoute:
      UserLayoutHelpHelpLayoutMyOptimizationIndexLazyRoute,
    UserLayoutHelpHelpLayoutMyTransactionsIndexLazyRoute:
      UserLayoutHelpHelpLayoutMyTransactionsIndexLazyRoute,
    UserLayoutHelpHelpLayoutOptimizationIndexLazyRoute:
      UserLayoutHelpHelpLayoutOptimizationIndexLazyRoute,
    UserLayoutHelpHelpLayoutProfileIndexLazyRoute:
      UserLayoutHelpHelpLayoutProfileIndexLazyRoute,
    UserLayoutHelpHelpLayoutSocialSecurityIndexLazyRoute:
      UserLayoutHelpHelpLayoutSocialSecurityIndexLazyRoute,
    UserLayoutHelpHelpLayoutSpecialChargesIndexLazyRoute:
      UserLayoutHelpHelpLayoutSpecialChargesIndexLazyRoute,
    UserLayoutHelpHelpLayoutTaxesIndexLazyRoute:
      UserLayoutHelpHelpLayoutTaxesIndexLazyRoute,
    UserLayoutHelpHelpLayoutTransactionActionsIndexLazyRoute:
      UserLayoutHelpHelpLayoutTransactionActionsIndexLazyRoute,
    UserLayoutHelpHelpLayoutVideoExplainIndexLazyRoute:
      UserLayoutHelpHelpLayoutVideoExplainIndexLazyRoute,
  }

const UserLayoutHelpHelpLayoutRouteWithChildren =
  UserLayoutHelpHelpLayoutRoute._addFileChildren(
    UserLayoutHelpHelpLayoutRouteChildren,
  )

interface UserLayoutHelpRouteChildren {
  UserLayoutHelpHelpLayoutRoute: typeof UserLayoutHelpHelpLayoutRouteWithChildren
}

const UserLayoutHelpRouteChildren: UserLayoutHelpRouteChildren = {
  UserLayoutHelpHelpLayoutRoute: UserLayoutHelpHelpLayoutRouteWithChildren,
}

const UserLayoutHelpRouteWithChildren = UserLayoutHelpRoute._addFileChildren(
  UserLayoutHelpRouteChildren,
)

interface UserLayoutManagementManagementLayoutRouteChildren {
  UserLayoutManagementManagementLayoutMyBusinessIndexLazyRoute: typeof UserLayoutManagementManagementLayoutMyBusinessIndexLazyRoute
  UserLayoutManagementManagementLayoutMyContributionsIndexLazyRoute: typeof UserLayoutManagementManagementLayoutMyContributionsIndexLazyRoute
  UserLayoutManagementManagementLayoutMySummaryIndexLazyRoute: typeof UserLayoutManagementManagementLayoutMySummaryIndexLazyRoute
  UserLayoutManagementManagementLayoutMyTaxIndexLazyRoute: typeof UserLayoutManagementManagementLayoutMyTaxIndexLazyRoute
  UserLayoutManagementManagementLayoutSocialContributionsIndexLazyRoute: typeof UserLayoutManagementManagementLayoutSocialContributionsIndexLazyRoute
}

const UserLayoutManagementManagementLayoutRouteChildren: UserLayoutManagementManagementLayoutRouteChildren =
  {
    UserLayoutManagementManagementLayoutMyBusinessIndexLazyRoute:
      UserLayoutManagementManagementLayoutMyBusinessIndexLazyRoute,
    UserLayoutManagementManagementLayoutMyContributionsIndexLazyRoute:
      UserLayoutManagementManagementLayoutMyContributionsIndexLazyRoute,
    UserLayoutManagementManagementLayoutMySummaryIndexLazyRoute:
      UserLayoutManagementManagementLayoutMySummaryIndexLazyRoute,
    UserLayoutManagementManagementLayoutMyTaxIndexLazyRoute:
      UserLayoutManagementManagementLayoutMyTaxIndexLazyRoute,
    UserLayoutManagementManagementLayoutSocialContributionsIndexLazyRoute:
      UserLayoutManagementManagementLayoutSocialContributionsIndexLazyRoute,
  }

const UserLayoutManagementManagementLayoutRouteWithChildren =
  UserLayoutManagementManagementLayoutRoute._addFileChildren(
    UserLayoutManagementManagementLayoutRouteChildren,
  )

interface UserLayoutManagementRouteChildren {
  UserLayoutManagementManagementLayoutRoute: typeof UserLayoutManagementManagementLayoutRouteWithChildren
}

const UserLayoutManagementRouteChildren: UserLayoutManagementRouteChildren = {
  UserLayoutManagementManagementLayoutRoute:
    UserLayoutManagementManagementLayoutRouteWithChildren,
}

const UserLayoutManagementRouteWithChildren =
  UserLayoutManagementRoute._addFileChildren(UserLayoutManagementRouteChildren)

interface UserLayoutProfileProfileLayoutRouteChildren {
  UserLayoutProfileProfileLayoutAccountingDataIndexLazyRoute: typeof UserLayoutProfileProfileLayoutAccountingDataIndexLazyRoute
  UserLayoutProfileProfileLayoutGeneralIndexLazyRoute: typeof UserLayoutProfileProfileLayoutGeneralIndexLazyRoute
  UserLayoutProfileProfileLayoutProfileFiscalIndexLazyRoute: typeof UserLayoutProfileProfileLayoutProfileFiscalIndexLazyRoute
  UserLayoutProfileProfileLayoutSocialSecurityIndexLazyRoute: typeof UserLayoutProfileProfileLayoutSocialSecurityIndexLazyRoute
}

const UserLayoutProfileProfileLayoutRouteChildren: UserLayoutProfileProfileLayoutRouteChildren =
  {
    UserLayoutProfileProfileLayoutAccountingDataIndexLazyRoute:
      UserLayoutProfileProfileLayoutAccountingDataIndexLazyRoute,
    UserLayoutProfileProfileLayoutGeneralIndexLazyRoute:
      UserLayoutProfileProfileLayoutGeneralIndexLazyRoute,
    UserLayoutProfileProfileLayoutProfileFiscalIndexLazyRoute:
      UserLayoutProfileProfileLayoutProfileFiscalIndexLazyRoute,
    UserLayoutProfileProfileLayoutSocialSecurityIndexLazyRoute:
      UserLayoutProfileProfileLayoutSocialSecurityIndexLazyRoute,
  }

const UserLayoutProfileProfileLayoutRouteWithChildren =
  UserLayoutProfileProfileLayoutRoute._addFileChildren(
    UserLayoutProfileProfileLayoutRouteChildren,
  )

interface UserLayoutProfileRouteChildren {
  UserLayoutProfileProfileLayoutRoute: typeof UserLayoutProfileProfileLayoutRouteWithChildren
}

const UserLayoutProfileRouteChildren: UserLayoutProfileRouteChildren = {
  UserLayoutProfileProfileLayoutRoute:
    UserLayoutProfileProfileLayoutRouteWithChildren,
}

const UserLayoutProfileRouteWithChildren =
  UserLayoutProfileRoute._addFileChildren(UserLayoutProfileRouteChildren)

interface UserLayoutRouteChildren {
  UserLayoutIndexLazyRoute: typeof UserLayoutIndexLazyRoute
  UserLayoutAbonnementPaiementRoute: typeof UserLayoutAbonnementPaiementRoute
  UserLayoutHelpRoute: typeof UserLayoutHelpRouteWithChildren
  UserLayoutManagementRoute: typeof UserLayoutManagementRouteWithChildren
  UserLayoutProfileRoute: typeof UserLayoutProfileRouteWithChildren
  UserLayoutAccountsListIndexLazyRoute: typeof UserLayoutAccountsListIndexLazyRoute
  UserLayoutOptimizationIndexLazyRoute: typeof UserLayoutOptimizationIndexLazyRoute
  UserLayoutTransactionsIndexLazyRoute: typeof UserLayoutTransactionsIndexLazyRoute
  UserLayoutUserInfoIndexLazyRoute: typeof UserLayoutUserInfoIndexLazyRoute
}

const UserLayoutRouteChildren: UserLayoutRouteChildren = {
  UserLayoutIndexLazyRoute: UserLayoutIndexLazyRoute,
  UserLayoutAbonnementPaiementRoute: UserLayoutAbonnementPaiementRoute,
  UserLayoutHelpRoute: UserLayoutHelpRouteWithChildren,
  UserLayoutManagementRoute: UserLayoutManagementRouteWithChildren,
  UserLayoutProfileRoute: UserLayoutProfileRouteWithChildren,
  UserLayoutAccountsListIndexLazyRoute: UserLayoutAccountsListIndexLazyRoute,
  UserLayoutOptimizationIndexLazyRoute: UserLayoutOptimizationIndexLazyRoute,
  UserLayoutTransactionsIndexLazyRoute: UserLayoutTransactionsIndexLazyRoute,
  UserLayoutUserInfoIndexLazyRoute: UserLayoutUserInfoIndexLazyRoute,
}

const UserLayoutRouteWithChildren = UserLayoutRoute._addFileChildren(
  UserLayoutRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof UserLayoutRouteWithChildren
  '/simulateur': typeof SimulateurLazyRoute
  '/verify-email': typeof VerifyEmailLazyRoute
  '/': typeof UserLayoutIndexLazyRoute
  '/Abonnement/paiement': typeof UserLayoutAbonnementPaiementRoute
  '/help': typeof UserLayoutHelpHelpLayoutRouteWithChildren
  '/management': typeof UserLayoutManagementManagementLayoutRouteWithChildren
  '/profile': typeof UserLayoutProfileProfileLayoutRouteWithChildren
  '/login': typeof AuthenticationLayoutLoginIndexLazyRoute
  '/accounts-list': typeof UserLayoutAccountsListIndexLazyRoute
  '/optimization': typeof UserLayoutOptimizationIndexLazyRoute
  '/transactions': typeof UserLayoutTransactionsIndexLazyRoute
  '/user-info': typeof UserLayoutUserInfoIndexLazyRoute
  '/help/banking': typeof UserLayoutHelpHelpLayoutBankingIndexLazyRoute
  '/help/my-activity': typeof UserLayoutHelpHelpLayoutMyActivityIndexLazyRoute
  '/help/my-optimization': typeof UserLayoutHelpHelpLayoutMyOptimizationIndexLazyRoute
  '/help/my-transactions': typeof UserLayoutHelpHelpLayoutMyTransactionsIndexLazyRoute
  '/help/optimization': typeof UserLayoutHelpHelpLayoutOptimizationIndexLazyRoute
  '/help/profile': typeof UserLayoutHelpHelpLayoutProfileIndexLazyRoute
  '/help/social-security': typeof UserLayoutHelpHelpLayoutSocialSecurityIndexLazyRoute
  '/help/special-charges': typeof UserLayoutHelpHelpLayoutSpecialChargesIndexLazyRoute
  '/help/taxes': typeof UserLayoutHelpHelpLayoutTaxesIndexLazyRoute
  '/help/transaction-actions': typeof UserLayoutHelpHelpLayoutTransactionActionsIndexLazyRoute
  '/help/video-explain': typeof UserLayoutHelpHelpLayoutVideoExplainIndexLazyRoute
  '/management/my-business': typeof UserLayoutManagementManagementLayoutMyBusinessIndexLazyRoute
  '/management/my-contributions': typeof UserLayoutManagementManagementLayoutMyContributionsIndexLazyRoute
  '/management/my-summary': typeof UserLayoutManagementManagementLayoutMySummaryIndexLazyRoute
  '/management/my-tax': typeof UserLayoutManagementManagementLayoutMyTaxIndexLazyRoute
  '/management/social-contributions': typeof UserLayoutManagementManagementLayoutSocialContributionsIndexLazyRoute
  '/profile/accounting-data': typeof UserLayoutProfileProfileLayoutAccountingDataIndexLazyRoute
  '/profile/general': typeof UserLayoutProfileProfileLayoutGeneralIndexLazyRoute
  '/profile/profile-fiscal': typeof UserLayoutProfileProfileLayoutProfileFiscalIndexLazyRoute
  '/profile/social-security': typeof UserLayoutProfileProfileLayoutSocialSecurityIndexLazyRoute
}

export interface FileRoutesByTo {
  '': typeof AuthenticationLayoutRouteWithChildren
  '/simulateur': typeof SimulateurLazyRoute
  '/verify-email': typeof VerifyEmailLazyRoute
  '/': typeof UserLayoutIndexLazyRoute
  '/Abonnement/paiement': typeof UserLayoutAbonnementPaiementRoute
  '/help': typeof UserLayoutHelpHelpLayoutRouteWithChildren
  '/management': typeof UserLayoutManagementManagementLayoutRouteWithChildren
  '/profile': typeof UserLayoutProfileProfileLayoutRouteWithChildren
  '/login': typeof AuthenticationLayoutLoginIndexLazyRoute
  '/accounts-list': typeof UserLayoutAccountsListIndexLazyRoute
  '/optimization': typeof UserLayoutOptimizationIndexLazyRoute
  '/transactions': typeof UserLayoutTransactionsIndexLazyRoute
  '/user-info': typeof UserLayoutUserInfoIndexLazyRoute
  '/help/banking': typeof UserLayoutHelpHelpLayoutBankingIndexLazyRoute
  '/help/my-activity': typeof UserLayoutHelpHelpLayoutMyActivityIndexLazyRoute
  '/help/my-optimization': typeof UserLayoutHelpHelpLayoutMyOptimizationIndexLazyRoute
  '/help/my-transactions': typeof UserLayoutHelpHelpLayoutMyTransactionsIndexLazyRoute
  '/help/optimization': typeof UserLayoutHelpHelpLayoutOptimizationIndexLazyRoute
  '/help/profile': typeof UserLayoutHelpHelpLayoutProfileIndexLazyRoute
  '/help/social-security': typeof UserLayoutHelpHelpLayoutSocialSecurityIndexLazyRoute
  '/help/special-charges': typeof UserLayoutHelpHelpLayoutSpecialChargesIndexLazyRoute
  '/help/taxes': typeof UserLayoutHelpHelpLayoutTaxesIndexLazyRoute
  '/help/transaction-actions': typeof UserLayoutHelpHelpLayoutTransactionActionsIndexLazyRoute
  '/help/video-explain': typeof UserLayoutHelpHelpLayoutVideoExplainIndexLazyRoute
  '/management/my-business': typeof UserLayoutManagementManagementLayoutMyBusinessIndexLazyRoute
  '/management/my-contributions': typeof UserLayoutManagementManagementLayoutMyContributionsIndexLazyRoute
  '/management/my-summary': typeof UserLayoutManagementManagementLayoutMySummaryIndexLazyRoute
  '/management/my-tax': typeof UserLayoutManagementManagementLayoutMyTaxIndexLazyRoute
  '/management/social-contributions': typeof UserLayoutManagementManagementLayoutSocialContributionsIndexLazyRoute
  '/profile/accounting-data': typeof UserLayoutProfileProfileLayoutAccountingDataIndexLazyRoute
  '/profile/general': typeof UserLayoutProfileProfileLayoutGeneralIndexLazyRoute
  '/profile/profile-fiscal': typeof UserLayoutProfileProfileLayoutProfileFiscalIndexLazyRoute
  '/profile/social-security': typeof UserLayoutProfileProfileLayoutSocialSecurityIndexLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authentication-layout': typeof AuthenticationLayoutRouteWithChildren
  '/_user-layout': typeof UserLayoutRouteWithChildren
  '/simulateur': typeof SimulateurLazyRoute
  '/verify-email': typeof VerifyEmailLazyRoute
  '/_user-layout/': typeof UserLayoutIndexLazyRoute
  '/_user-layout/Abonnement/paiement': typeof UserLayoutAbonnementPaiementRoute
  '/_user-layout/help': typeof UserLayoutHelpRouteWithChildren
  '/_user-layout/help/_help-layout': typeof UserLayoutHelpHelpLayoutRouteWithChildren
  '/_user-layout/management': typeof UserLayoutManagementRouteWithChildren
  '/_user-layout/management/_management-layout': typeof UserLayoutManagementManagementLayoutRouteWithChildren
  '/_user-layout/profile': typeof UserLayoutProfileRouteWithChildren
  '/_user-layout/profile/_profile-layout': typeof UserLayoutProfileProfileLayoutRouteWithChildren
  '/_authentication-layout/login/': typeof AuthenticationLayoutLoginIndexLazyRoute
  '/_user-layout/accounts-list/': typeof UserLayoutAccountsListIndexLazyRoute
  '/_user-layout/optimization/': typeof UserLayoutOptimizationIndexLazyRoute
  '/_user-layout/transactions/': typeof UserLayoutTransactionsIndexLazyRoute
  '/_user-layout/user-info/': typeof UserLayoutUserInfoIndexLazyRoute
  '/_user-layout/help/_help-layout/banking/': typeof UserLayoutHelpHelpLayoutBankingIndexLazyRoute
  '/_user-layout/help/_help-layout/my-activity/': typeof UserLayoutHelpHelpLayoutMyActivityIndexLazyRoute
  '/_user-layout/help/_help-layout/my-optimization/': typeof UserLayoutHelpHelpLayoutMyOptimizationIndexLazyRoute
  '/_user-layout/help/_help-layout/my-transactions/': typeof UserLayoutHelpHelpLayoutMyTransactionsIndexLazyRoute
  '/_user-layout/help/_help-layout/optimization/': typeof UserLayoutHelpHelpLayoutOptimizationIndexLazyRoute
  '/_user-layout/help/_help-layout/profile/': typeof UserLayoutHelpHelpLayoutProfileIndexLazyRoute
  '/_user-layout/help/_help-layout/social-security/': typeof UserLayoutHelpHelpLayoutSocialSecurityIndexLazyRoute
  '/_user-layout/help/_help-layout/special-charges/': typeof UserLayoutHelpHelpLayoutSpecialChargesIndexLazyRoute
  '/_user-layout/help/_help-layout/taxes/': typeof UserLayoutHelpHelpLayoutTaxesIndexLazyRoute
  '/_user-layout/help/_help-layout/transaction-actions/': typeof UserLayoutHelpHelpLayoutTransactionActionsIndexLazyRoute
  '/_user-layout/help/_help-layout/video-explain/': typeof UserLayoutHelpHelpLayoutVideoExplainIndexLazyRoute
  '/_user-layout/management/_management-layout/my-business/': typeof UserLayoutManagementManagementLayoutMyBusinessIndexLazyRoute
  '/_user-layout/management/_management-layout/my-contributions/': typeof UserLayoutManagementManagementLayoutMyContributionsIndexLazyRoute
  '/_user-layout/management/_management-layout/my-summary/': typeof UserLayoutManagementManagementLayoutMySummaryIndexLazyRoute
  '/_user-layout/management/_management-layout/my-tax/': typeof UserLayoutManagementManagementLayoutMyTaxIndexLazyRoute
  '/_user-layout/management/_management-layout/social-contributions/': typeof UserLayoutManagementManagementLayoutSocialContributionsIndexLazyRoute
  '/_user-layout/profile/_profile-layout/accounting-data/': typeof UserLayoutProfileProfileLayoutAccountingDataIndexLazyRoute
  '/_user-layout/profile/_profile-layout/general/': typeof UserLayoutProfileProfileLayoutGeneralIndexLazyRoute
  '/_user-layout/profile/_profile-layout/profile-fiscal/': typeof UserLayoutProfileProfileLayoutProfileFiscalIndexLazyRoute
  '/_user-layout/profile/_profile-layout/social-security/': typeof UserLayoutProfileProfileLayoutSocialSecurityIndexLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/simulateur'
    | '/verify-email'
    | '/'
    | '/Abonnement/paiement'
    | '/help'
    | '/management'
    | '/profile'
    | '/login'
    | '/accounts-list'
    | '/optimization'
    | '/transactions'
    | '/user-info'
    | '/help/banking'
    | '/help/my-activity'
    | '/help/my-optimization'
    | '/help/my-transactions'
    | '/help/optimization'
    | '/help/profile'
    | '/help/social-security'
    | '/help/special-charges'
    | '/help/taxes'
    | '/help/transaction-actions'
    | '/help/video-explain'
    | '/management/my-business'
    | '/management/my-contributions'
    | '/management/my-summary'
    | '/management/my-tax'
    | '/management/social-contributions'
    | '/profile/accounting-data'
    | '/profile/general'
    | '/profile/profile-fiscal'
    | '/profile/social-security'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/simulateur'
    | '/verify-email'
    | '/'
    | '/Abonnement/paiement'
    | '/help'
    | '/management'
    | '/profile'
    | '/login'
    | '/accounts-list'
    | '/optimization'
    | '/transactions'
    | '/user-info'
    | '/help/banking'
    | '/help/my-activity'
    | '/help/my-optimization'
    | '/help/my-transactions'
    | '/help/optimization'
    | '/help/profile'
    | '/help/social-security'
    | '/help/special-charges'
    | '/help/taxes'
    | '/help/transaction-actions'
    | '/help/video-explain'
    | '/management/my-business'
    | '/management/my-contributions'
    | '/management/my-summary'
    | '/management/my-tax'
    | '/management/social-contributions'
    | '/profile/accounting-data'
    | '/profile/general'
    | '/profile/profile-fiscal'
    | '/profile/social-security'
  id:
    | '__root__'
    | '/_authentication-layout'
    | '/_user-layout'
    | '/simulateur'
    | '/verify-email'
    | '/_user-layout/'
    | '/_user-layout/Abonnement/paiement'
    | '/_user-layout/help'
    | '/_user-layout/help/_help-layout'
    | '/_user-layout/management'
    | '/_user-layout/management/_management-layout'
    | '/_user-layout/profile'
    | '/_user-layout/profile/_profile-layout'
    | '/_authentication-layout/login/'
    | '/_user-layout/accounts-list/'
    | '/_user-layout/optimization/'
    | '/_user-layout/transactions/'
    | '/_user-layout/user-info/'
    | '/_user-layout/help/_help-layout/banking/'
    | '/_user-layout/help/_help-layout/my-activity/'
    | '/_user-layout/help/_help-layout/my-optimization/'
    | '/_user-layout/help/_help-layout/my-transactions/'
    | '/_user-layout/help/_help-layout/optimization/'
    | '/_user-layout/help/_help-layout/profile/'
    | '/_user-layout/help/_help-layout/social-security/'
    | '/_user-layout/help/_help-layout/special-charges/'
    | '/_user-layout/help/_help-layout/taxes/'
    | '/_user-layout/help/_help-layout/transaction-actions/'
    | '/_user-layout/help/_help-layout/video-explain/'
    | '/_user-layout/management/_management-layout/my-business/'
    | '/_user-layout/management/_management-layout/my-contributions/'
    | '/_user-layout/management/_management-layout/my-summary/'
    | '/_user-layout/management/_management-layout/my-tax/'
    | '/_user-layout/management/_management-layout/social-contributions/'
    | '/_user-layout/profile/_profile-layout/accounting-data/'
    | '/_user-layout/profile/_profile-layout/general/'
    | '/_user-layout/profile/_profile-layout/profile-fiscal/'
    | '/_user-layout/profile/_profile-layout/social-security/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticationLayoutRoute: typeof AuthenticationLayoutRouteWithChildren
  UserLayoutRoute: typeof UserLayoutRouteWithChildren
  SimulateurLazyRoute: typeof SimulateurLazyRoute
  VerifyEmailLazyRoute: typeof VerifyEmailLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticationLayoutRoute: AuthenticationLayoutRouteWithChildren,
  UserLayoutRoute: UserLayoutRouteWithChildren,
  SimulateurLazyRoute: SimulateurLazyRoute,
  VerifyEmailLazyRoute: VerifyEmailLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authentication-layout",
        "/_user-layout",
        "/simulateur",
        "/verify-email"
      ]
    },
    "/_authentication-layout": {
      "filePath": "_authentication-layout.tsx",
      "children": [
        "/_authentication-layout/login/"
      ]
    },
    "/_user-layout": {
      "filePath": "_user-layout.tsx",
      "children": [
        "/_user-layout/",
        "/_user-layout/Abonnement/paiement",
        "/_user-layout/help",
        "/_user-layout/management",
        "/_user-layout/profile",
        "/_user-layout/accounts-list/",
        "/_user-layout/optimization/",
        "/_user-layout/transactions/",
        "/_user-layout/user-info/"
      ]
    },
    "/simulateur": {
      "filePath": "simulateur.lazy.tsx"
    },
    "/verify-email": {
      "filePath": "verify-email.lazy.tsx"
    },
    "/_user-layout/": {
      "filePath": "_user-layout/index.lazy.tsx",
      "parent": "/_user-layout"
    },
    "/_user-layout/Abonnement/paiement": {
      "filePath": "_user-layout/Abonnement/paiement.tsx",
      "parent": "/_user-layout"
    },
    "/_user-layout/help": {
      "filePath": "_user-layout/help",
      "parent": "/_user-layout",
      "children": [
        "/_user-layout/help/_help-layout"
      ]
    },
    "/_user-layout/help/_help-layout": {
      "filePath": "_user-layout/help/_help-layout.tsx",
      "parent": "/_user-layout/help",
      "children": [
        "/_user-layout/help/_help-layout/banking/",
        "/_user-layout/help/_help-layout/my-activity/",
        "/_user-layout/help/_help-layout/my-optimization/",
        "/_user-layout/help/_help-layout/my-transactions/",
        "/_user-layout/help/_help-layout/optimization/",
        "/_user-layout/help/_help-layout/profile/",
        "/_user-layout/help/_help-layout/social-security/",
        "/_user-layout/help/_help-layout/special-charges/",
        "/_user-layout/help/_help-layout/taxes/",
        "/_user-layout/help/_help-layout/transaction-actions/",
        "/_user-layout/help/_help-layout/video-explain/"
      ]
    },
    "/_user-layout/management": {
      "filePath": "_user-layout/management",
      "parent": "/_user-layout",
      "children": [
        "/_user-layout/management/_management-layout"
      ]
    },
    "/_user-layout/management/_management-layout": {
      "filePath": "_user-layout/management/_management-layout.tsx",
      "parent": "/_user-layout/management",
      "children": [
        "/_user-layout/management/_management-layout/my-business/",
        "/_user-layout/management/_management-layout/my-contributions/",
        "/_user-layout/management/_management-layout/my-summary/",
        "/_user-layout/management/_management-layout/my-tax/",
        "/_user-layout/management/_management-layout/social-contributions/"
      ]
    },
    "/_user-layout/profile": {
      "filePath": "_user-layout/profile",
      "parent": "/_user-layout",
      "children": [
        "/_user-layout/profile/_profile-layout"
      ]
    },
    "/_user-layout/profile/_profile-layout": {
      "filePath": "_user-layout/profile/_profile-layout.tsx",
      "parent": "/_user-layout/profile",
      "children": [
        "/_user-layout/profile/_profile-layout/accounting-data/",
        "/_user-layout/profile/_profile-layout/general/",
        "/_user-layout/profile/_profile-layout/profile-fiscal/",
        "/_user-layout/profile/_profile-layout/social-security/"
      ]
    },
    "/_authentication-layout/login/": {
      "filePath": "_authentication-layout/login/index.lazy.tsx",
      "parent": "/_authentication-layout"
    },
    "/_user-layout/accounts-list/": {
      "filePath": "_user-layout/accounts-list/index.lazy.tsx",
      "parent": "/_user-layout"
    },
    "/_user-layout/optimization/": {
      "filePath": "_user-layout/optimization/index.lazy.tsx",
      "parent": "/_user-layout"
    },
    "/_user-layout/transactions/": {
      "filePath": "_user-layout/transactions/index.lazy.tsx",
      "parent": "/_user-layout"
    },
    "/_user-layout/user-info/": {
      "filePath": "_user-layout/user-info/index.lazy.tsx",
      "parent": "/_user-layout"
    },
    "/_user-layout/help/_help-layout/banking/": {
      "filePath": "_user-layout/help/_help-layout/banking/index.lazy.tsx",
      "parent": "/_user-layout/help/_help-layout"
    },
    "/_user-layout/help/_help-layout/my-activity/": {
      "filePath": "_user-layout/help/_help-layout/my-activity/index.lazy.tsx",
      "parent": "/_user-layout/help/_help-layout"
    },
    "/_user-layout/help/_help-layout/my-optimization/": {
      "filePath": "_user-layout/help/_help-layout/my-optimization/index.lazy.tsx",
      "parent": "/_user-layout/help/_help-layout"
    },
    "/_user-layout/help/_help-layout/my-transactions/": {
      "filePath": "_user-layout/help/_help-layout/my-transactions/index.lazy.tsx",
      "parent": "/_user-layout/help/_help-layout"
    },
    "/_user-layout/help/_help-layout/optimization/": {
      "filePath": "_user-layout/help/_help-layout/optimization/index.lazy.tsx",
      "parent": "/_user-layout/help/_help-layout"
    },
    "/_user-layout/help/_help-layout/profile/": {
      "filePath": "_user-layout/help/_help-layout/profile/index.lazy.tsx",
      "parent": "/_user-layout/help/_help-layout"
    },
    "/_user-layout/help/_help-layout/social-security/": {
      "filePath": "_user-layout/help/_help-layout/social-security/index.lazy.tsx",
      "parent": "/_user-layout/help/_help-layout"
    },
    "/_user-layout/help/_help-layout/special-charges/": {
      "filePath": "_user-layout/help/_help-layout/special-charges/index.lazy.tsx",
      "parent": "/_user-layout/help/_help-layout"
    },
    "/_user-layout/help/_help-layout/taxes/": {
      "filePath": "_user-layout/help/_help-layout/taxes/index.lazy.tsx",
      "parent": "/_user-layout/help/_help-layout"
    },
    "/_user-layout/help/_help-layout/transaction-actions/": {
      "filePath": "_user-layout/help/_help-layout/transaction-actions/index.lazy.tsx",
      "parent": "/_user-layout/help/_help-layout"
    },
    "/_user-layout/help/_help-layout/video-explain/": {
      "filePath": "_user-layout/help/_help-layout/video-explain/index.lazy.tsx",
      "parent": "/_user-layout/help/_help-layout"
    },
    "/_user-layout/management/_management-layout/my-business/": {
      "filePath": "_user-layout/management/_management-layout/my-business/index.lazy.tsx",
      "parent": "/_user-layout/management/_management-layout"
    },
    "/_user-layout/management/_management-layout/my-contributions/": {
      "filePath": "_user-layout/management/_management-layout/my-contributions/index.lazy.tsx",
      "parent": "/_user-layout/management/_management-layout"
    },
    "/_user-layout/management/_management-layout/my-summary/": {
      "filePath": "_user-layout/management/_management-layout/my-summary/index.lazy.tsx",
      "parent": "/_user-layout/management/_management-layout"
    },
    "/_user-layout/management/_management-layout/my-tax/": {
      "filePath": "_user-layout/management/_management-layout/my-tax/index.lazy.tsx",
      "parent": "/_user-layout/management/_management-layout"
    },
    "/_user-layout/management/_management-layout/social-contributions/": {
      "filePath": "_user-layout/management/_management-layout/social-contributions/index.lazy.tsx",
      "parent": "/_user-layout/management/_management-layout"
    },
    "/_user-layout/profile/_profile-layout/accounting-data/": {
      "filePath": "_user-layout/profile/_profile-layout/accounting-data/index.lazy.tsx",
      "parent": "/_user-layout/profile/_profile-layout"
    },
    "/_user-layout/profile/_profile-layout/general/": {
      "filePath": "_user-layout/profile/_profile-layout/general/index.lazy.tsx",
      "parent": "/_user-layout/profile/_profile-layout"
    },
    "/_user-layout/profile/_profile-layout/profile-fiscal/": {
      "filePath": "_user-layout/profile/_profile-layout/profile-fiscal/index.lazy.tsx",
      "parent": "/_user-layout/profile/_profile-layout"
    },
    "/_user-layout/profile/_profile-layout/social-security/": {
      "filePath": "_user-layout/profile/_profile-layout/social-security/index.lazy.tsx",
      "parent": "/_user-layout/profile/_profile-layout"
    }
  }
}
ROUTE_MANIFEST_END */
